import React from "react";
import { Link } from "react-router-dom";
import { Typography, makeStyles, Grid, Button } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    minHeight: "100vh",
    display: "flex",
    alignItems: "center",
    [theme.breakpoints.down("sm")]: {
      marginTop: "30px",
    },
  },
  contentContainer: {
    width: "90%",
    maxWidth: "1280px",
    margin: "0 auto",
    boxShadow: `0px 0px 14px 5px ${theme.palette.secondary.dark}`,
  },
  sectionHeading: {
    fontSize: "72px",
    fontWeight: 600,
    letterSpacing: 0.1,
    margin: "20px 0px",
    lineHeight: "60px",
    [theme.breakpoints.down("md")]: {
      fontSize: "60px",
    },
    [theme.breakpoints.down("sm")]: {
      fontSize: "48px",
      lineHeight: "40px",
      marginTop: "30px",
    },
  },
  note1: {
    margin: "15px 0",
    fontWeight: 600,
  },
  note2: {
    color: theme.palette.secondary.dark,
    marginLeft: "20px",
    fontSize: "24px",
    fontWeight: "500",
  },
  featPubInfo: {
    padding: "60px 70px",
    [theme.breakpoints.down("md")]: {
      padding: "20px 30px",
    },
  },
  featPubImg: {
    width: "90%",
    maxWidth: "360px",
    marginTop: "-70px",
    [theme.breakpoints.down("md")]: {
      margin: "20px 0",
    },
    [theme.breakpoints.down("sm")]: {
      width: "100%",
    },
  },
  exploreBtn:{
    color: 'black',
    marginLeft: '20px',
    boxShadow: 'none',
    borderRadius: 2,
    padding: '10px 75px',
    margin: '20px 0',
    '&:hover':{
        color: theme.palette.secondary.light
    }
}
}));

function FeaturedPublications() {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <div className={classes.contentContainer}>
        <Grid container>
          <Grid item xs={12} sm={12} md={7} lg={7} xl={7}>
            <div className={classes.featPubInfo}>
              <h2 className={classes.sectionHeading}>Feature Publications</h2>
              <Typography
                variant="body1"
                color="error"
                className={classes.note1}
              >
                History of Methamphetamine
              </Typography>
              <p>
                A riveting, true account of a boy’s journey to becoming Hawaii’s
                largest animist sophisticated ice trafficker, and the FBI’s
                ambitious attempt to infiltrate his reported $100 million dollar
                enterprise and take him down…
              </p>
              <p>
                Competently iterate team building potentialities and team driven
                alignments. Appropriately enhance cost effective web-readiness
                for sticky collaboration and idea-sharing. Collaboratively
                disseminate cross functional collaboration and idea-sharing
                without
              </p>
            </div>
          </Grid>
          <Grid
            item
            xs={12}
            sm={12}
            md={5}
            lg={5}
            xl={5}
            style={{ textAlign: "center" }}
          >
            <img
              src="./assets/images/feat-pub.jpg"
              alt="feat_pub"
              className={classes.featPubImg}
            />
            <Link to="/shop" style={{ textDecoration: "none" }}>
              <Button
                color="primary"
                variant="contained"
                className={classes.exploreBtn}
              >
                Learn More
              </Button>
            </Link>
          </Grid>
        </Grid>
      </div>
    </div>
  );
}

export default FeaturedPublications;
